import { PixelRatio } from "react-native";
import { isMobileApp } from "src/Themes/variables";

export const normalize = (size: number) => {
  const sizeCoefficient = isMobileApp ? 1 : 1.3;
  return Math.round(PixelRatio.roundToNearestPixel(size * sizeCoefficient));
};
